document.addEventListener("DOMContentLoaded", function () {
  if (typeof jQuery === "undefined") return;

  const $slider = jQuery("#custom-slider-template--21106756059366__featured_collection");

  if ($slider.length && !$slider.hasClass("slick-initialized")) {
    $slider.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      centerMode: true,
      centerPadding: "155px",
      arrows: true,
      dots: false,
      speed: 500,
      autoplay: true,

      prevArrow: `<button type="button" class="slick-prev custom-arrow">‹</button>`,
      nextArrow: `<button type="button" class="slick-next custom-arrow">›</button>`,

responsive: [
  {
    breakpoint: 1700,  // new largest screen
    settings: {
      slidesToShow: 4,
      centerMode: true,
      centerPadding: "120px"
    }
  },
  {
    breakpoint: 1400,
    settings: {
      slidesToShow: 3,
      centerMode: true,
      centerPadding: "100px"
    }
  },
  {
    breakpoint: 1200,
    settings: {
      slidesToShow: 3,
      centerMode: true,
      centerPadding: "90px"
    }
  },
  {
    breakpoint: 990,
    settings: {
      slidesToShow: 2,
      centerMode: true,
      centerPadding: "90px"
    }
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 2,
      centerMode: true,
      centerPadding: "50px"
    }
  },
  {
    breakpoint: 600,
    settings: {
      slidesToShow: 1,
      centerMode: true,
      centerPadding: "30px"
    }
  }
]
    });
  }

  /* ===============================
     STICKY HEADER
  =============================== */

  function stickyHeader() {
    if (jQuery(window).scrollTop() > 1) {
      jQuery(".header-wrapper").addClass("sticky");
    } else {
      jQuery(".header-wrapper").removeClass("sticky");
    }
  }

  stickyHeader();
  jQuery(window).on("scroll", stickyHeader);

});


document.addEventListener("DOMContentLoaded", function () {

  function waitForReviewsAndInit() {

    var $ = window.jQuery;

    if (!$ || !$.fn.slick) {
      setTimeout(waitForReviewsAndInit, 300);
      return;
    }

    var slider = document.querySelector('.agrs__body');

    if (!slider || slider.children.length < 2) {
      setTimeout(waitForReviewsAndInit, 500);
      return;
    }

    var $slider = $('.agrs__body');

    if ($slider.hasClass('slick-initialized')) return;

    $slider.css('display', 'block');

    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2500,
      speed: 600,
      arrows: true,
      dots: false,
      centerMode: true,
      centerPadding: '155px',

      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: "90px"
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: "70px"
          }
        }
      ]
    });

  }

  waitForReviewsAndInit();

});


(function () {
  function initSlider(sliderEl) {
    var $slider = jQuery(sliderEl);
    var slideCount = $slider.children().length;

    var isDesktop = window.innerWidth >= 1200;

    if (slideCount < 5 && isDesktop) {
      $slider.css('opacity', '1'); // ensure visible
      return;
    }

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    // Hide grid layout before Slick touches it — prevents FOUC
    $slider.css('opacity', '0');

    $slider.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      speed: 500,
      centerMode: true,
      centerPadding: '155px',
      responsive: [
        { breakpoint: 1700, settings: { slidesToShow: 4, centerMode: true, centerPadding: '120px' } },
        { breakpoint: 1400, settings: { slidesToShow: 3, centerMode: true, centerPadding: '100px' } },
        { breakpoint: 1200, settings: { slidesToShow: 3, centerMode: true, centerPadding: '90px' } },
        { breakpoint: 990,  settings: { slidesToShow: 2, centerMode: true, centerPadding: '90px' } },
        { breakpoint: 768,  settings: { slidesToShow: 2, centerMode: true, centerPadding: '50px' } },
        { breakpoint: 600,  settings: { slidesToShow: 1, centerMode: true, centerPadding: '30px' } }
      ]
    });

    // Fade in after Slick has restructured the DOM
    $slider.css('opacity', '1');
  }

  function waitForJQuerySlick(callback) {
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick === 'function') {
      callback();
    } else {
      setTimeout(function () { waitForJQuerySlick(callback); }, 300);
    }
  }

  function observeRecommendations() {
    var productRec = document.querySelector('product-recommendations');
    if (!productRec) return;

    // MutationObserver watches for when the web component injects its children
    var observer = new MutationObserver(function (mutations, obs) {
      var sliderEl = productRec.querySelector('.related-products-grid');

      if (sliderEl && sliderEl.children.length > 0) {
        obs.disconnect(); // Stop watching once content is injected
        waitForJQuerySlick(function () {
          initSlider(sliderEl);
        });
      }
    });

    observer.observe(productRec, { childList: true, subtree: true });

    // Fallback: if content is already there (e.g. cached response)
    var existingGrid = productRec.querySelector('.related-products-grid');
    if (existingGrid && existingGrid.children.length > 0) {
      observer.disconnect();
      waitForJQuerySlick(function () {
        initSlider(existingGrid);
      });
    }
  }

  // Entry points
  window.addEventListener('load', observeRecommendations);

  document.addEventListener('shopify:section:load', function () {
    setTimeout(observeRecommendations, 200);
  });
})();




document.addEventListener('DOMContentLoaded', function () {
  const isMobile = () => window.innerWidth <= 767;

  const footerColumns = document.querySelectorAll('.footer-column');

  footerColumns.forEach((column) => {
    const heading = column.querySelector('.footer-column-heading');
    const menu = column.querySelector('.footer-menu');

    if (!heading || !menu) return;

    // Initial state on mobile
    if (isMobile()) {
      menu.style.display = 'none';
    }

    heading.addEventListener('click', function () {
      if (!isMobile()) return;

      const isActive = column.classList.contains('active');

      // Close all columns
      footerColumns.forEach((col) => {
        col.classList.remove('active');
        const m = col.querySelector('.footer-menu');
        if (m) m.style.display = 'none';
      });

      // Open clicked one if it wasn't active
      if (!isActive) {
        column.classList.add('active');
        menu.style.display = 'block';
      }
    });
  });

  // Reset on resize
  window.addEventListener('resize', function () {
    footerColumns.forEach((column) => {
      const menu = column.querySelector('.footer-menu');
      if (!menu) return;

      if (!isMobile()) {
        menu.style.display = '';
        column.classList.remove('active');
      } else {
        if (!column.classList.contains('active')) {
          menu.style.display = 'none';
        }
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("backToTopBtn");

  if (!btn) return;

  window.addEventListener("scroll", function () {
    if (window.scrollY > 300) {
      btn.style.display = "block";
    } else {
      btn.style.display = "none";
    }
  });

  btn.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
});



document.addEventListener('DOMContentLoaded', function () {
  function checkProductCount() {
    const productCountEl = document.getElementById('ProductCountDesktop');
    const facetForm = document.querySelector('facet-filters-form.facets-vertical-sort');

    if (productCountEl && facetForm) {
      const countText = productCountEl.textContent.trim();
      const count = parseInt(countText, 10);

      if (count === 0) {
        facetForm.style.display = 'none';
      } else {
        facetForm.style.display = '';
      }
    }
  }

  // Run on page load
  checkProductCount();

  // Also observe DOM changes (for AJAX/filter updates)
  const observer = new MutationObserver(checkProductCount);
  const target = document.getElementById('ProductCountDesktop');
  if (target) {
    observer.observe(target, { childList: true, subtree: true, characterData: true });
  }
});


document.addEventListener("DOMContentLoaded", function () {

  const menuItems = document.querySelectorAll('.header__inline-menu details');

  menuItems.forEach((item) => {

    item.addEventListener('mouseenter', () => {
      item.setAttribute('open', true);
    });

    item.addEventListener('mouseleave', () => {
      item.removeAttribute('open');
    });

  });

});
document.addEventListener("DOMContentLoaded", function () {
  const content = document.querySelector(".collection-read-more");
  const button = document.querySelector(".read-more-toggle");

  if (!content || !button) return;

  // Hide content initially
  content.style.display = "none";

  button.addEventListener("click", function (e) {
    e.preventDefault();

    const isHidden = content.style.display === "none";

    content.style.display = isHidden ? "block" : "none";
    button.textContent = isHidden ? "Read Less" : "Read More";
  });
});

(function () {
    function hidePowrHeading() {
        const powr = document.querySelector('powr-form-builder');

        if (!powr || !powr.shadowRoot) return;

        const shadowRoot = powr.shadowRoot;

        if (shadowRoot.querySelector('#powr-heading-custom-style')) return;

        const style = document.createElement('style');

        style.id = 'powr-heading-custom-style';

        style.textContent = `
            div.text-center:has(img[src*="powr-logo.svg"]) {
                display: none !important;
            }

            .form-content-wrapper{
              padding-inline:50px !important;
            }

            div.absolute.inset-0.flex.items-center.justify-center.pointer-events-none span.text-base{
            color:#fff !important;
            }

            div.absolute.inset-0.flex.items-center.justify-center.pointer-events-none svg{
            color:#fff !important;}

            .form-container{
    margin-top:100px !important;
    }

    @media(max-width:992px){
      #widget-root{
      margin-inline:15px !important;}
    }

       .form-container{
    margin-top:30px !important;
    }

     .form-content-wrapper{
              padding-inline:20px !important;
            }
}

        `;

        shadowRoot.appendChild(style);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', hidePowrHeading, { once: true });
    } else {
        hidePowrHeading();
    }

    const observer = new MutationObserver(hidePowrHeading);

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });

    if (window.customElements) {
        customElements.whenDefined('powr-form-builder').then(hidePowrHeading);
    }
})();